import * as React from "react"
import { cn } from "@/lib/utils"

export interface EthereumLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Size of the logo in pixels
   * @default 24
   */
  size?: number
}

/**
 * Ethereum logo component
 *
 * Displays the Ethereum cryptocurrency logo.
 *
 * @example
 * ```tsx
 * <EthereumLogo />
 * <EthereumLogo size={32} />
 * <EthereumLogo className="opacity-75" />
 * ```
 */
export const EthereumLogo = React.forwardRef<HTMLImageElement, EthereumLogoProps>(
  ({ size = 24, className, style, alt = "Ethereum", ...props }, ref) => {
    return (
      <img
        ref={ref}
        src="/icons/ethereum.svg"
        alt={alt}
        className={cn("inline-block", className)}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          ...style
        }}
        {...props}
      />
    )
  }
)

EthereumLogo.displayName = "EthereumLogo"